import { Box, Typography } from "@mui/material";
import { useTheme } from "../../../contexts/ThemeContext";

export const FeatureItem = ({ icon, title, text }) => {
	const { theme } = useTheme();

	return (
		<Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
			<Box sx={{ fontSize: 40, color: theme.color.primary }}>{icon}</Box>
			<Typography variant="h6" sx={{ mt: 2, mb: 1, color: theme.color.primary, fontFamily: theme.fontFamily, }}>
				{title}
			</Typography>
			<Typography variant="body2" sx={{ color: theme.text.primary, fontFamily: theme.fontFamily, }}>
				{text}
			</Typography>
		</Box>
	)
};